import { Image } from "antd";
import React from "react";
import faceBookIcon from "../../assets/icons/Facebook - Original.svg";
import twitterIcon from "../../assets/icons/Twitter - Original.svg";
import googleIcon from "../../assets/icons/Google - Original.svg";

const OAuthBox = () => {
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          alignItems: "center",
          margin: "2.5rem 0",
        }}
      >
        <hr style={{ color: "#A0A0A0", width: "40%" }} />
        <span style={{ color: "#A0A0A0", fontWeight: "300", fontSize: "18px" }}>
          or
        </span>
        <hr style={{ color: "#A0A0A0", width: "40%" }} />
      </div>
      <div>
        <div
          style={{
            display: "flex  ",
            justifyContent: "space-evenly",
            marginBottom: "3rem",
          }}
        >
          <Image
            src={faceBookIcon}
            onClick={() => console.log("rr")}
            preview={false}
            width={34}
            height={34}
            style={{
              cursor: "pointer",
            }}
          />
          <Image
            src={twitterIcon}
            onClick={() => console.log("rr")}
            preview={false}
            width={34}
            height={34}
            style={{
              cursor: "pointer",
            }}
          />
          <Image
            src={googleIcon}
            onClick={() => console.log("rr")}
            preview={false}
            width={34}
            height={34}
            style={{
              cursor: "pointer",
            }}
          />
        </div>
      </div>
    </>
  );
};

export default OAuthBox;
